import { LAYOUTS } from "@voltmoney/types";
import SharedPropsService from "../../../SharedPropsService";
import { ROUTE } from "../../../routes";
import { WIDGET } from "@voltmoney/schema";
import _ from "lodash";
import { api } from "../../../configs/api";
import { getAppHeader } from "../../../configs/config";
import { ACTION } from "./types";
import { doneAction, goBack, navigateToTransaction, needHelp } from "./action";
import { convertTimeStampToFormattedTime } from "../../../configs/utils";
export const template = (height, stepperData, res, accountNumber, bankName, bankCode, isFirstJourney, verifyOTPResponse) => ({
    layout: {
        id: ROUTE.WITHDRAW_REQUEST,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            {
                id: "withdrawRequestScreen",
                type: WIDGET.REQUEST_WITHDRAW,
            },
        ],
    },
    datastore: {
        withdrawRequestScreen: {
            height: height,
            stepperData: stepperData,
            goBackAction: {
                type: ACTION.GO_BACK,
                routeId: ROUTE.WITHDRAW_REQUEST,
            },
            needHelpAction: {
                type: ACTION.NEED_HELP,
                routeId: ROUTE.WITHDRAW_REQUEST,
                payload: {}
            },
            doneAction: {
                type: ACTION.DONE_ACTION,
                routeId: ROUTE.WITHDRAW_REQUEST,
                payload: {}
            },
            navigateToTransaction: {
                type: ACTION.NAVIGATE_TRANSACTION,
                routeId: ROUTE.WITHDRAW_REQUEST,
                payload: {}
            },
            loading: false,
            res,
            accountNumber,
            bankName,
            bankCode,
            isFirstJourney,
            verifyOTPResponse
        }
    },
});
export const withdrawRequestScreenMF = {
    onLoad: async ({ network, instrumentTrack, getHeight }, { res, disbursalCreatedOn, isFirstJourney, verifyOTPResponse }) => {
        instrumentTrack('WITHDRAW_SUCCESS_PAGE_VIEWED');
        const expectedTransferDate = res?.expectedTransferBy;
        const user = await SharedPropsService.getUser();
        const accountId = user.linkedBorrowerAccounts[0].accountId;
        const response = await network.get(`${api.userProfile}${accountId}`, {
            headers: await getAppHeader(),
        });
        const accountNumber = _.get(response, "data.bankDetails.accountNumber", null);
        const bankName = _.get(response, "data.bankDetails.bankName", "");
        const bankCode = _.get(response, "data.bankDetails.bankCode", "");
        const stepperData = [
            {
                "status": "COMPLETED",
                "verticalDisplayName": "Withdrawal request received",
                "verticalDescription": `Placed on ${convertTimeStampToFormattedTime(verifyOTPResponse?.createdOn)}`,
                "order": 0
            },
            {
                "status": "IN_PROGRESS",
                "verticalDisplayName": "Expected transfer by",
                "verticalDescription": `${convertTimeStampToFormattedTime(verifyOTPResponse?.expectedTransferBy)}`,
                "order": 1
            },
        ];
        //   );
        return Promise.resolve(template(getHeight(), stepperData, res, accountNumber, bankName, bankCode, isFirstJourney, verifyOTPResponse));
    },
    actions: {
        [ACTION.GO_BACK]: goBack,
        [ACTION.NEED_HELP]: needHelp,
        [ACTION.DONE_ACTION]: doneAction,
        [ACTION.NAVIGATE_TRANSACTION]: navigateToTransaction,
    },
};
